import type { Space } from "@/react/types/Space";
import {
  CurrentSpaceContextProvider,
  CustomizeSpaceContextProvider,
} from "@circle-react/contexts";
import { CustomizeSpaceLayout } from "./CustomizeSpaceLayout";
import { Modal } from "./Modal";

interface CustomizeSpaceFullPageProps {
  initialSection?: string;
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
  onSave: ({ data, onSuccess }: { data: any; onSuccess: () => void }) => void;
  onSlugChange: (space?: Space) => void;
  scrollToId?: string;
  sections?: string[];
  space?: Space;
}

export const CustomizeSpaceFullPage = ({
  isOpen,
  onExit,
  onClose,
  onSave,
  space,
  sections,
  initialSection,
  onSlugChange,
  scrollToId,
}: CustomizeSpaceFullPageProps) => {
  if (!space) return null;

  return (
    <CurrentSpaceContextProvider spaceId={space.id}>
      <CustomizeSpaceContextProvider onSlugChange={onSlugChange}>
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          onExit={onExit}
          onSave={onSave}
          sections={sections}
          initialSection={initialSection}
          title={space.name}
        >
          <CustomizeSpaceLayout
            space={space}
            scrollToId={scrollToId}
            onClose={onClose}
          />
        </Modal>
      </CustomizeSpaceContextProvider>
    </CurrentSpaceContextProvider>
  );
};
